import { useNavigate } from 'react-router-dom';
import SITE from '../data/site';

export default function Footer() {
  const nav = useNavigate();
  const { clinic } = SITE;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            {clinic.logo
              ? <img src={clinic.logo} className="footer-logo" alt={clinic.name} onError={e => e.target.style.display='none'} />
              : <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🦷</div>
            }
            <p>يضم مركز العراب نخبة من أفضل أطباء الأسنان المؤهلين وذوي خبرة في مجال طب الأسنان في علاج وتجميل الأسنان باستخدام أحدث التقنيات والأجهزة الطبية.</p>
          </div>
          <div className="footer-col">
            <h4>روابط رئيسية</h4>
            <ul>
              {[['/', 'الرئيسية'], ['/about', 'من نحن'], ['/services', 'خدماتنا'], ['/contact', 'تواصل معنا']].map(([path, label]) => (
                <li key={path}><span onClick={() => nav(path)}>✦ {label}</span></li>
              ))}
            </ul>
          </div>
          <div className="footer-col">
            <h4>تواصل معنا</h4>
            <div className="footer-ci">📍 <span>{clinic.address}</span></div>
            <div className="footer-ci">📞 <a href={`tel:${clinic.phone}`}>{clinic.phone}</a></div>
            <div className="footer-ci">✉️ <a href={`mailto:${clinic.email}`}>{clinic.email}</a></div>
            <div className="footer-ci">💬 <a href={clinic.whatsapp} target="_blank" rel="noreferrer">واتساب</a></div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © {new Date().getFullYear()} — {clinic.name}. جميع الحقوق محفوظة.</p>
        </div>
      </div>
    </footer>
  );
}
